/* =================== TABS =================== */
jQuery(document).ready(function($){
	$('.tabs-abas li').on('click', function() {
    var tabId = $(this).data('tab');

    var yourArray = {};
    yourArray['referencia_id'] = $(this).data('referencia');
    $('.modal-insert').data('campos', yourArray);
    console.log($('.modal-insert').data('campos'));

    $('.tabs-abas li').removeClass('active');
    $('.tab-content').removeClass('active');

    $('#'+tabId).addClass('active');
    $(this).addClass('active');	    
  });

});
